/* eslint-disable */
export default {
  logging: '正在记录…',
  logCall: '记录通话',
  editLog: '编辑记录',
  select: '选择匹配记录',
  OnHold: '暂候',
  Ringing: '正在振铃',
  CallConnected: '呼叫已接通',
  unknownUser: '未知用户',
  unknownNumber: '匿名',
  unavailable: '不可用',
  viewDetails: '查看详细信息',
  addEntity: '新建',
  addLog: '记录',
  text: '短信',
  call: '电话',
  addContact: '添加联系人',
  missedCall: '未接',
  inboundCall: '入站',
  outboundCall: '呼出',
  from: '自',
  to: '至',
  hangup: '挂断',
  accept: '接听',
  toVoicemail: '到语音信箱',
  anonymous: '匿名',
  mergeToConference: '与进行中的通话合并',
  hold: '保持',
  unhold: '解除保持',
  transfer: '转接',
  reject: '拒绝',
  switchCall: '将呼叫切换到此应用',
  callSwitch: '呼叫切换',
  comfirmContext: '您当前正在与 {displayName} 通话。是否要在此设备上继续通话？',
  comfirmCancelButton: '取消',
  comfirmOKButton: '切换',
  ignore: '忽略',
  holdAndAnswer: '保持并接听',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
